module.exports = __webpack_public_path__ + "site/img/41.1a400a2e.jpg";